// extracted by mini-css-extract-plugin
export var exploreMapSwitch = "styles-module__exploreMapSwitch___Vp4Yk";